import { render, staticRenderFns } from "./image-annotator.vue?vue&type=template&id=48e604f5&scoped=true&"
import script from "./image-annotator.vue?vue&type=script&lang=js&"
export * from "./image-annotator.vue?vue&type=script&lang=js&"
import style0 from "./image-annotator.vue?vue&type=style&index=0&id=48e604f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e604f5",
  null
  
)

export default component.exports